jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

  function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
  }

  waitForElm('.sb-product').then(elm => {
    const sidebarProductBlock = $(elm);
    if (sidebarProductBlock.length > 0) {
      sidebarProductBlock.find('[name="id"]').change(function(e) {
        const optionSelected = $("option:selected", this);
        $('.sb-product__img').addClass("hidden");
        $(`.sb-product__img[data-variant-id="${e.target.value}"]`).removeClass("hidden");
        $('.sb-product__price').text(optionSelected.data("price"))
      });
    }
  })
});